export default __webpack_public_path__ + "static/media/fi-24-hours-48.4dc6dca9.svg";